import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  compact?: boolean;
}

const Logo = ({ compact = false }: LogoProps) => {
  return (
    <Link
      href={'/'}
      className="mr-4 flex w-fit flex-shrink-0 cursor-pointer items-center max-xs:gap-1.5 xs:gap-2.5 lg:gap-2"
    >
      <div className="flex min-w-10 items-center">
        <Image src="/logo.svg" alt="Logo" width={46} height={46} />
      </div>
      <div className="flex flex-col justify-center">
        <span className={`${compact ? 'hidden lg:block' : 'flex'} items-center text-2xl font-medium text-primary`}>
          Vergabepilot.AI
        </span>
        <span className="hidden text-sm font-light lg:block">Die KI für Ausschreibungen</span>
      </div>
    </Link>
  );
};

export default Logo;
